import styled from 'styled-components';
import {Link} from "react-router-dom";

import {ChevronLeft, ChevronRight} from "lucide-react";
import {themecolors} from "../utils/themecolors";

const MaybeLink = ({ to, className, children, onClick }) =>
    to ? <Link to={to} className={className} onClick={onClick}>{children}</Link>
        : <div className={className} disabled>{children}</div>;
const Paginate = styled.div``;
const Previous = styled(MaybeLink)``;
const Next = styled(MaybeLink)``;

const Pagination = styled(({className, path, has_more, page, hidePrevious}) => {
    const backToTop = () => {
        window.scrollTo(0,0);
    }
    return (
        <Paginate className={className}>
            {page > 1 && !hidePrevious &&
            <Previous to={!page || page > 1 && `${path}${page ? page - 1 : ''}`} onClick={backToTop}>
                <ChevronLeft size={18} style={{marginRight: '6px'}} />
                 Previous
            </Previous>
            }
            {has_more && <Next to={has_more && `${path}${page ? page+1 : ''}`} onClick={backToTop}>
                Next
                <ChevronRight size={18} style={{marginLeft: '6px'}} />
            </Next>}
        </Paginate>
    );
})`
  display: flex;
  justify-content: flex-start;
  padding: 20px 0;

  ${Previous}, ${Next} {
    padding: 6px 12px;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
    display: flex;
    align-items: center;
  }
  ${Next} {
    margin-left: auto;
  }

  ${Previous} {
    margin-right: 8px;
  }
  @media only screen and (max-width: 780px) {
    margin-left: 8px;
  }
`;

export default Pagination;
